'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _leafletGeosearch = require('leaflet-geosearch');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var $ = jQuery;
var $document = $(document);

var MapService = require('./map-service.js');
var GeocodingResult = require('../geocoding-result.js');
var utils = require('../utils.js');
var RouteAnimator = require('../route-animator.js');

var LeafletOSMMapService = function (_MapService) {
	_inherits(LeafletOSMMapService, _MapService);

	function LeafletOSMMapService($canvas, settings) {
		_classCallCheck(this, LeafletOSMMapService);

		var _this2 = _possibleConstructorReturn(this, (LeafletOSMMapService.__proto__ || Object.getPrototypeOf(LeafletOSMMapService)).call(this, $canvas, settings));

		_this2.currentTilesetUrl = settings.map.tileset;
		_this2.layers = {
			'road': [L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],
			'terrain': [L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],

			'slate': [L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
				subdomains: 'abcd', // 🔧 REQUIRED for Carto
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],
			'zen': [L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
				subdomains: 'abcd', // 🔧 REQUIRED for Carto
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],
			'darkmode': [L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png', {
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>',
				subdomains: 'abcd', // 🔧 REQUIRED for Carto
				minZoom: 2,
				maxZoom: 16
			})],
			'topography': [L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>',
				minZoom: 2,
				maxZoom: 16

			})],

			'adventure': [L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', {
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],

			'ourplanet': [L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],

			'satellite': [L.tileLayer('https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}', {
				minZoom: 2,
				maxZoom: 16,
				attribution: '© <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a> | © <a target="_blank" href="https://mapsamurai.com">MapSamurai</a>'
			})],

			'image': [L.tileLayer(settings.map.tileset.replace(/\/+$/, '') + '/z{z}-tile_{y}_{x}.png', {
				minZoom: -2, // Allow more zoomed out view for intro animation
				maxZoom: 4,
				noWrap: true,
				tms: true
			})]

		};
		_this2.settings = settings;
		_this2.markers = [];
		_this2.audioUnlocked = false;
		_this2.weatherLayers = {}; // Store weather layer references
		_this2.cluster = L.markerClusterGroup({
			zoomToBoundsOnClick: false, // Disable default behavior
			maxClusterRadius: 80,
			iconCreateFunction: function iconCreateFunction(cluster) {
				var count = cluster.getChildCount();
				var size = 'small';
				var sizeClass = 'marker-cluster-small';

				if (count < 10) {
					size = 'small';
					sizeClass = 'marker-cluster-small';
				} else if (count < 100) {
					size = 'medium';
					sizeClass = 'marker-cluster-medium';
				} else {
					size = 'large';
					sizeClass = 'marker-cluster-large';
				}

				var icon = new L.DivIcon({
					html: '<div class="cluster-icon-wrapper">' + '<span class="cluster-count">' + count + '</span>' + '<span class="cluster-magnifier">🔍</span>' + '</div>',
					className: 'marker-cluster ' + sizeClass + ' mapsamurai-cluster',
					iconSize: new L.Point(40, 40)
				});

				return icon;
			}
		});
		_this2.geocoder = new _leafletGeosearch.OpenStreetMapProvider();
		_this2.$canvas = $canvas;

		_this2.worldBounds = [[-85, -180], // Southwest coordinates
		[85, 180] // Northeast coordinates
		];
		_this2.type = null;

		_this2.map = L.map(_this2.$canvas.get(0), {
			'attributionControl': false,
			'zoomControl': false,
			'doubleClickZoom': false,
			'scrollWheelZoom': _this2.settings.zoom.enabled,
			'attribution': '',
			'maxBoundsViscosity': 0.9,
			'zoomAnimation': true,
			'zoomAnimationThreshold': 4,
			'minZoom': -2, // Allow negative zoom for intro animations
			'maxZoom': 16
		});

		_this2.map.on('dblclick', function (e) {
			return $(_this2).trigger('dblclick', e.latlng);
		});

		// Unlock audio on any map click (user gesture)
		_this2.map.on('click', function () {
			return _this2.unlockAudio();
		});

		// Temperature marker click handler
		_this2.map.on('click', function (e) {
			$(_this2).trigger('mapsamurai.map.clicked', {
				lat: e.latlng.lat,
				lng: e.latlng.lng
			});
		});

		// Track tile loading state
		_this2._tilesLoading = 0;
		_this2.map.on('tileloadstart', function () {
			_this2._tilesLoading++;
		});
		_this2.map.on('tileload', function () {
			_this2._tilesLoading--;
			if (_this2._tilesLoading === 0) {
				_this2.map.fire('tilelayersload');
			}
		});
		_this2.map.on('tileerror', function () {
			_this2._tilesLoading--;
		});

		_this2.map.addLayer(_this2.cluster);

		// Add custom cluster click handler for better zoom behavior
		_this2.cluster.on('clusterclick', function (e) {
			_this2.handleClusterClick(e);
		});

		_this2.markersContainer = _this2.settings.cluster.enabled ? _this2.cluster : _this2.map;

		// Initialize route animator
		_this2.routeAnimator = new RouteAnimator(_this2);
		// Override the moveMarker method for Leaflet-specific implementation
		_this2.routeAnimator.moveMarker = _this2.moveMarkerToPosition.bind(_this2);
		// Override the hideMarker and showMarker methods for Leaflet-specific implementation
		_this2.routeAnimator.hideMarker = _this2.hideMarkerDuringDelay.bind(_this2);
		_this2.routeAnimator.showMarker = _this2.showMarkerAfterDelay.bind(_this2);

		_this2.StealthLocateControl = L.Control.Locate.extend({
			onAdd: function onAdd(m) {
				// do not render a button
				this._layer = this.options.layer || L.layerGroup();
				this._layer.addTo(m);
				this._event = undefined;
				this._prevBounds = null;

				var container = L.DomUtil.create('div');
				var linkAndIcon = this.options.createButtonCallback(container, this.options);
				this._link = linkAndIcon.link;
				this._icon = linkAndIcon.icon;

				this._resetVariables();

				this._map.on('unload', this._unload, this);

				return container;
			}
		});

		_this2.attributionControl = L.control.attribution({
			prefix: false,
			position: 'bottomleft'
		});
		_this2.map.addControl(_this2.attributionControl);

		_this2.locateControl = new _this2.StealthLocateControl({
			icon: 'icon-null-class',
			iconLoading: 'icon-loading-null-class'
		});
		_this2.locateControl.addTo(_this2.map);

		_this2.$canvas.css({
			'background': _this2.settings.map.background
		});

		// Setup weather layers if enabled
		_this2.setupWeatherLayers();
		return _this2;
	}

	_createClass(LeafletOSMMapService, [{
		key: 'setupWeatherLayers',
		value: function setupWeatherLayers() {
			var _this3 = this;

			// Check if weather is enabled and we have layers
			if (!this.settings.weather || !this.settings.weather.enabled || !this.settings.weather.layers || this.settings.weather.layers.length === 0) {
				return;
			}

			// Get API key from global settings
			var apiKey = window.mapsamurai_script_settings && window.mapsamurai_script_settings.weather_api_key;
			if (!apiKey) {
				return;
			}

			// Get opacity (0-1 range)
			var opacity = this.settings.weather.opacity || 0.6;

			// Add each enabled weather layer
			this.settings.weather.layers.forEach(function (layerType) {
				_this3.addWeatherLayer(layerType, apiKey, opacity);
			});
		}
	}, {
		key: 'addWeatherLayer',
		value: function addWeatherLayer(layerType, apiKey, opacity) {
			// Check if layer already exists
			if (this.weatherLayers[layerType]) {
				return;
			}

			var tileUrl = 'https://tile.openweathermap.org/map/' + layerType + '/{z}/{x}/{y}.png?appid=' + apiKey;

			// Create tile layer for this weather type (but don't add to map yet)
			var weatherLayer = L.tileLayer(tileUrl, {
				attribution: '', // Don't add attribution - handled elsewhere
				opacity: opacity,
				maxZoom: 16,
				minZoom: 2,
				zIndex: 1000, // Ensure weather layers render on top of base map
				pane: 'overlayPane' // Use overlay pane to ensure proper layering
			});

			// Store reference (but don't add to map - WeatherControls will handle visibility)
			this.weatherLayers[layerType] = weatherLayer;

			// Listen for tile loading events to debug
			weatherLayer.on('loading', function () {});

			weatherLayer.on('load', function () {});

			weatherLayer.on('tileerror', function (error) {
				// Log the failed tile URL
				if (error && error.tile && error.tile.src) {}
			});

			weatherLayer.on('tileload', function (e) {});
		}
	}, {
		key: 'removeWeatherLayer',
		value: function removeWeatherLayer(layerType) {
			if (this.weatherLayers[layerType]) {
				this.map.removeLayer(this.weatherLayers[layerType]);
				delete this.weatherLayers[layerType];
			}
		}
	}, {
		key: 'setWeatherOpacity',
		value: function setWeatherOpacity(opacity) {
			var _this4 = this;

			Object.keys(this.weatherLayers).forEach(function (layerType) {
				if (_this4.weatherLayers[layerType]) {
					_this4.weatherLayers[layerType].setOpacity(opacity);
				}
			});
		}
	}, {
		key: 'getWeatherFilterString',
		value: function getWeatherFilterString() {
			var brightness = this.settings.weather.brightness || 1;
			var contrast = this.settings.weather.contrast || 1;
			var saturation = this.settings.weather.saturation || 1;
			var hue = this.settings.weather.hue || 0;

			return 'brightness(' + brightness + ') contrast(' + contrast + ') saturate(' + saturation + ') hue-rotate(' + hue + 'deg)';
		}
	}, {
		key: 'applyWeatherFilters',
		value: function applyWeatherFilters(layer, layerType) {
			if (!layer || !layer.getContainer) {
				return;
			}

			// Check if color adjustments are enabled for this specific layer type
			var colorAdjustmentLayers = this.settings.weather.colorAdjustmentLayers || [];
			if (!colorAdjustmentLayers.includes(layerType)) {
				return;
			}

			var container = layer.getContainer();
			if (container) {
				container.style.filter = this.getWeatherFilterString();
			}
		}
	}, {
		key: 'showWeatherLayer',
		value: function showWeatherLayer(layerType) {
			var _this5 = this;

			if (this.weatherLayers[layerType]) {
				var layer = this.weatherLayers[layerType];

				// Add layer to map with fade-in
				layer.setOpacity(0);
				layer.addTo(this.map);

				// Apply CSS filters once the layer container is available
				setTimeout(function () {
					_this5.applyWeatherFilters(layer, layerType);
				}, 10);

				// Fade in
				setTimeout(function () {
					layer.setOpacity(_this5.settings.weather.opacity || 0.6);
				}, 50);
			}
		}
	}, {
		key: 'hideWeatherLayer',
		value: function hideWeatherLayer(layerType) {
			var _this6 = this;

			if (this.weatherLayers[layerType]) {
				var layer = this.weatherLayers[layerType];

				// Fade out before removing
				layer.setOpacity(0);

				// Remove after fade transition
				setTimeout(function () {
					if (_this6.map.hasLayer(layer)) {
						_this6.map.removeLayer(layer);
					}
				}, 300);
			}
		}
	}, {
		key: 'updateWeatherLayerTime',
		value: function updateWeatherLayerTime(layerType, timestamp) {
			var _this7 = this;

			if (!this.weatherLayers[layerType]) {
				return;
			}

			var apiKey = window.mapsamurai_script_settings && window.mapsamurai_script_settings.weather_api_key;
			if (!apiKey) {
				return;
			}

			var oldLayer = this.weatherLayers[layerType];
			var opacity = oldLayer.options.opacity;

			// Fade out old layer
			oldLayer.setOpacity(0);

			// Wait for fade out, then swap layers
			setTimeout(function () {
				// Remove old layer
				if (_this7.map.hasLayer(oldLayer)) {
					_this7.map.removeLayer(oldLayer);
				}

				// Create new layer with timestamp
				var tileUrl = 'https://tile.openweathermap.org/map/' + layerType + '/{z}/{x}/{y}.png?appid=' + apiKey + '&date=' + timestamp;

				var newLayer = L.tileLayer(tileUrl, {
					attribution: '',
					opacity: 0,
					maxZoom: 16,
					minZoom: 2,
					zIndex: 1000,
					pane: 'overlayPane'
				});

				// Add new layer and fade in
				newLayer.addTo(_this7.map);

				// Apply CSS filters
				setTimeout(function () {
					_this7.applyWeatherFilters(newLayer, layerType);
				}, 10);

				setTimeout(function () {
					newLayer.setOpacity(opacity);
				}, 50);

				_this7.weatherLayers[layerType] = newLayer;
			}, 300);
		}
	}, {
		key: 'setType',
		value: function setType(type) {
			var _this8 = this;

			// Check if we need to update the image tile layer URL
			if (type === 'image' && this.settings.map.tileset && this.settings.map.tileset !== this.currentTilesetUrl) {
				this.updateImageTileLayer(this.settings.map.tileset);
			} else {
				// Normal layer switching for other types or when URLs haven't changed
				for (var layerType in this.layers) {
					var layerGroup = this.layers[layerType];
					for (var i = 0; i < layerGroup.length; i++) {
						this.map.removeLayer(layerGroup[i]);
					}
				}

				for (var i = 0; i < this.layers[type].length; i++) {
					this.map.addLayer(this.layers[type][i]);
				}
			}

			this.type = type;
			setTimeout(function () {
				if (type === 'image') {
					_this8.map.setMaxBounds(null);
					_this8.map.setMinZoom(-2); // Allow negative zoom for intro animation
					_this8.map.setMaxZoom(4);

					// Force current zoom to be within limits
					var currentZoom = _this8.map.getZoom();
					if (currentZoom > 4) {
						_this8.map.setZoom(4);
					}
				} else {
					_this8.map.setMaxBounds(_this8.worldBounds);
					_this8.map.setMinZoom(2);
					_this8.map.setMaxZoom(16);
				}
			}, 0);
		}
	}, {
		key: 'getCenter',
		value: function getCenter() {
			return this.map.getCenter();
		}
	}, {
		key: 'setCenter',
		value: function setCenter(center) {
			var _this = this;
			return new Promise(function (resolve) {
				_this.map.once('moveend', resolve);
				_this.map.panTo(center, { animate: true });
			});
		}
	}, {
		key: 'setZoom',
		value: function setZoom(zoom) {
			var _this = this;
			return new Promise(function (resolve) {
				// Respect zoom limits for image mode (allow -2 to 4)
				if (_this.type === 'image') {
					var originalZoom = zoom;
					zoom = Math.max(-2, Math.min(4, zoom));
				}

				if (_this.map.getZoom() === zoom) {
					resolve();
					return;
				}
				_this.map.once('zoomend', resolve);
				_this.map.flyTo(_this.map.getCenter(), zoom); // 👈 uses animated fly
			});
		}
	}, {
		key: 'getZoom',
		value: function getZoom() {
			return this.map.getZoom();
		}
	}, {
		key: 'addPinWithIcon',
		value: function addPinWithIcon(pin, icon) {
			var _this = this;
			var markerOptions = {
				'draggable': false,
				'riseOnHover': true
			};
			if (icon) {
				markerOptions.icon = icon;
			}
			if (pin.model.animatePinpointsType && pin.model.animatePinpointsType !== 'no' && !this.settings.cluster.enabled) {
				if (pin.model.animatePinpointsType === 'bounce') {
					markerOptions.bounceOnAdd = true;
				}
				// Fade-in animation will be handled after marker creation
			}
			var marker = L.marker(pin.model.latlng, markerOptions);
			marker._MapSamurai = pin;

			// Store the original icon for preservation during cluster operations
			if (markerOptions.icon) {
				marker._originalIcon = markerOptions.icon;
			}

			if (pin.isVisible()) {
				this.markersContainer.addLayer(marker);
				// Ensure icon is set after adding to cluster
				if (marker._originalIcon && this.settings.cluster.enabled) {
					marker.setIcon(marker._originalIcon);
				}
			}
			this.markers.push(marker);

			// Events - only enable hover on non-mobile devices
			if (!utils.isPhone()) {
				marker.on('mouseover', function (e) {
					var pin = this._MapSamurai;
					pin.mouseover = true;
					setTimeout(function () {
						pin.mouseover = false;
					});
					_this.showMarkerTooltip(this);
					_this.playHoverAudio(pin);
				});

				marker.on('mouseout', function (e) {
					var pin = this._MapSamurai;
					var tooltip = pin.tooltip;
					if (!tooltip) {
						return;
					}
					tooltip.node().trigger({
						'type': 'tooltip_mouseout'
					});
					_this.stopHoverAudio(pin);
				});
			}

			marker.on('click', function (e) {
				var marker = this;
				var pin = marker._MapSamurai;
				var tooltip = pin.tooltip;

				// Unlock audio on marker click (user gesture)
				_this.unlockAudio();

				var hover = function hover() {
					_this.showMarkerTooltip(marker);
					_this.playHoverAudio(pin);
				};

				var click = function click() {
					$document.trigger('mapsamurai.action.openPopup', {
						value: pin.model.id
					});
				};

				if (tooltip && !tooltip.node().is(':visible')) {
					hover();
					return;
				}
				click();
			});

			if (pin.tooltip) {
				this.map.on('movestart', function () {
					pin.tooltip.hide();
				});
				this.map.on('moveend', function () {
					pin.tooltip.hide();
				});
				this.map.on('zoomstart', function () {
					pin.tooltip.hide();
				});
				this.map.on('zoomend', function () {
					pin.tooltip.hide();
				});
				this.map.on('viewreset', function () {
					pin.tooltip.hide();
				});
			}
		}
	}, {
		key: 'addPin',
		value: function addPin(pin) {
			var _this = this;

			return new Promise(function (resolve, reject) {
				var onImageLoaded = function onImageLoaded() {
					var width = pin.model.image.size ? pin.model.image.size[0] : 0;
					var height = pin.model.image.size ? pin.model.image.size[1] : 0;

					// Check if we have explicit size, otherwise get from image
					if (!width) {
						width = pin.image.width;
						height = pin.image.height;
					}

					// Handle SVG images that don't have natural dimensions
					var isSvg = pin.model.image.url.toLowerCase().includes('.svg');
					if (isSvg && (!width || !height || width === 0 || height === 0)) {
						// Check if we have custom size from PHP (which includes custom marker width)
						if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
							width = pin.model.image.size[0];
							height = pin.model.image.size[1];
						} else {
							// Default SVG marker size - can be customized via PHP filter
							// apply_filters('mapsamurai_svg_marker_size', [32, 32], pin.model.image.url)
							width = window.mapsamurai_svg_marker_width || 32;
							height = window.mapsamurai_svg_marker_height || 32;
						}
					}

					// For SVG files, use custom size if available, otherwise apply default limit
					if (isSvg) {
						// If we have custom size from PHP (includes custom marker width), use it
						if (pin.model.image.size && pin.model.image.size[0] && pin.model.image.size[1]) {
							width = pin.model.image.size[0];
							height = pin.model.image.size[1];
						} else if (width > 40) {
							// Only apply 40px limit if no custom size was set
							var aspectRatio = height / width;
							width = 40;
							height = Math.round(width * aspectRatio);
						}
					}

					// Ensure we have valid dimensions
					if (!width || !height) {
						width = 25; // Default marker width
						height = 41; // Default marker height (typical marker shape)
					}

					// Use anchor from PHP if available, otherwise default to bottom center
					var anchor = [Math.floor(width / 2), height]; // Default: bottom center
					if (pin.model.image.anchor && pin.model.image.anchor.length >= 2) {
						anchor = [pin.model.image.anchor[0], pin.model.image.anchor[1]];
					}

					var icon = L.icon({
						'iconUrl': pin.model.image.url,
						'iconSize': [width, height],
						'iconAnchor': anchor
					});
					_this.addPinWithIcon(pin, icon);
					resolve();
				};

				if (pin.model.image.url) {
					if (pin.image.complete) {
						onImageLoaded();
					} else {
						pin.image.onload = onImageLoaded;
						pin.image.onLoad = pin.image.onload;
					}
				} else {
					_this.addPinWithIcon(pin, null);
					resolve();
				}
			});
		}
	}, {
		key: 'addPins',
		value: function addPins(pins) {
			var promises = [];
			for (var i = 0; i < pins.length; i++) {
				var pin = pins[i];
				promises.push(this.addPin(pin));
			}
			return Promise.all(promises);
		}
	}, {
		key: 'showTooltip',
		value: function showTooltip(tooltip, latLng, anchor) {
			var $win = $(window);
			if (tooltip.node().is(':visible')) {
				return false;
			}

			var containerPoint = this.map.latLngToContainerPoint(latLng);
			var left = this.$canvas.offset().left + containerPoint.x - Math.ceil(tooltip.node().width() / 2) + anchor[0];
			var top = this.$canvas.offset().top + containerPoint.y - tooltip.node().height() + anchor[1];

			if ($win.width() >= 767 && tooltip.node().hasClass('mpfy-tooltip-image-orientation-left') && tooltip.node().hasClass('mpfy-tooltip-with-thumbnail')) {
				var left = this.$canvas.offset().left + containerPoint.x - Math.ceil(tooltip.node().width() / 2) + anchor[0];
			};

			setTimeout(function () {
				tooltip.node().trigger({
					'type': 'tooltip_mouseover',
					'settings': {
						'left': left,
						'top': top
					}
				});
			}, 100);
		}
	}, {
		key: 'showMarkerTooltip',
		value: function showMarkerTooltip(marker) {
			var _this = this;
			var latLng = marker.getLatLng();
			var pin = marker._MapSamurai;
			var tooltip = pin.tooltip;

			if (!tooltip) {
				return;
			}

			var anchor = [0, -10];
			if (pin.model.image.url) {
				var isSvg = pin.model.image.url.toLowerCase().includes('.svg');

				if (isSvg) {
					// For SVG images, use the actual resized dimensions
					var svgWidth = window.mapsamurai_svg_marker_width || 32;
					var svgHeight = window.mapsamurai_svg_marker_height || 32;

					// Apply the same 40px width limit and aspect ratio we use in addPin
					if (svgWidth > 40) {
						var aspectRatio = svgHeight / svgWidth;
						svgWidth = 40;
						svgHeight = Math.round(svgWidth * aspectRatio);
					}

					// Use the resized height for positioning with 15px padding
					anchor[1] -= svgHeight + 15;
				} else {
					// For regular images, use original logic with some padding adjustment
					if (pin.model.image.anchor[1] > 0) {
						anchor[1] -= pin.model.image.anchor[1] + 5; // Add small padding for regular images too
					} else {
						anchor[1] -= pin.image.height + 5; // Add small padding for regular images too
					}
				}
			} else {
				anchor[1] = -50; // default pin height
			}

			if (utils.isPhone()) {
				// Position marker at bottom center of map, with tooltip appearing above
				var mapHeight = _this.map.getSize().y;
				var offset = 80; // fixed pixel offset from center

				var targetPoint = _this.map.project(latLng, _this.getZoom());
				var targetLatLng = _this.map.unproject(targetPoint.subtract(L.point([0, offset])));

				_this.setCenter(targetLatLng).then(function () {
					_this.showTooltip(tooltip, latLng, anchor);
				});
			} else {
				_this.showTooltip(tooltip, latLng, anchor);
			}
		}
	}, {
		key: 'geocode',
		value: function geocode(query) {
			return this.geocoder.search({ query: query }).then(function (results) {
				var filteredResults = [];
				for (var i = 0; i < results.length; i++) {
					var result = results[i];
					filteredResults.push(new GeocodingResult(result.label, result.y, result.x));
				}
				return Promise.resolve(filteredResults);
			});
		}
	}, {
		key: 'getPinsWithinRange',
		value: function getPinsWithinRange(lat, lng, rangeInMeters) {
			var target = [lat, lng];
			return this.markers.filter(function (marker) {
				var distance = marker.getLatLng().distanceTo(target);
				return distance <= rangeInMeters;
			}).map(function (marker) {
				return marker._MapSamurai;
			});
		}
	}, {
		key: 'getPinClosestTo',
		value: function getPinClosestTo(lat, lng) {
			var lowestDistance = -1;
			var closestPin = null;

			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				var distance = marker.getLatLng().distanceTo([lat, lng]);
				if (lowestDistance < 0 || distance < lowestDistance) {
					lowestDistance = distance;
					closestPin = marker._MapSamurai;
				}
			}
			return closestPin;
		}
	}, {
		key: 'getPinDistance',
		value: function getPinDistance(lat, lng, pin) {
			var marker = this.getPinMarker(pin);
			var distance = marker.getLatLng().distanceTo([lat, lng]);
			return distance;
		}

		// Audio management methods

	}, {
		key: 'unlockAudio',
		value: function unlockAudio() {
			var _this9 = this;

			if (this.audioUnlocked) {
				return;
			}

			// Create a silent audio element and attempt to play it to unlock audio context
			try {
				var silentAudio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmEeCC2L0fPSezQCHnrC6+OWRgsVXKvy1KhTEAg+ltryzoAgByt+0e3egTAFHHfJ7N2QQAoUXKvy05lPEQ1FAAA=');
				silentAudio.volume = 0.01;
				silentAudio.play().then(function () {
					_this9.audioUnlocked = true;
				}).catch(function (error) {
					// Silently handle unlock failure
				});
			} catch (e) {
				// Silently handle exceptions
			}
		}
	}, {
		key: 'createAudioPlayer',
		value: function createAudioPlayer(pin) {
			if (!pin.model.hoverAudio || pin.audioElement) {
				return;
			}

			pin.audioElement = new Audio(pin.model.hoverAudio);
			pin.audioElement.preload = 'metadata';
			pin.audioElement.volume = 0.7; // Set to 70% volume

			// Handle audio loading errors
			pin.audioElement.onerror = function () {
				pin.audioElement = null;
			};
		}
	}, {
		key: 'playHoverAudio',
		value: function playHoverAudio(pin) {
			// Try to unlock audio on hover (may not work due to browser policy)
			this.unlockAudio();

			// Stop any currently playing audio
			this.stopAllHoverAudio();

			if (!pin.model.hoverAudio) {
				return;
			}

			// Create audio element if it doesn't exist
			this.createAudioPlayer(pin);

			if (pin.audioElement) {
				pin.audioElement.currentTime = 0; // Start from beginning
				pin.audioElement.play().catch(function (error) {
					// Silently handle playback failure
				}.bind(this));
			}
		}
	}, {
		key: 'stopHoverAudio',
		value: function stopHoverAudio(pin) {
			if (pin.audioElement) {
				pin.audioElement.pause();
				pin.audioElement.currentTime = 0;
			}
		}
	}, {
		key: 'stopAllHoverAudio',
		value: function stopAllHoverAudio() {
			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				var pin = marker._MapSamurai;
				this.stopHoverAudio(pin);
			}
		}
	}, {
		key: 'highlightPin',
		value: function highlightPin(pin) {
			var _this10 = this;

			var _this = this;
			var marker = this.getPinMarker(pin);
			if (!marker) {
				return Promise.resolve();
			}

			return Promise.resolve().then(function () {
				var promises = _this10.markers.map(function (marker) {
					var currentPin = marker._MapSamurai;
					currentPin.setVisibility('base', true);
					return _this.updatePinVisibility(currentPin);
				});

				return Promise.all(promises);
			}).then(function () {
				if (!_this.settings.cluster.enabled) {
					return Promise.resolve();
				}
				var zoomToLayer = Promise.promisify(_this.cluster.zoomToShowLayer, { context: _this.cluster });
				return zoomToLayer(marker);
			}).then(function () {
				return _this.setCenter(marker.getLatLng());
			}).then(function () {
				return _this.showMarkerTooltip(marker);
			});
		}
	}, {
		key: 'getPinMarker',
		value: function getPinMarker(pin) {
			for (var i = 0; i < this.markers.length; i++) {
				var marker = this.markers[i];
				if (marker._MapSamurai === pin) {
					return marker;
				}
			}
			return null;
		}
	}, {
		key: 'fitPins',
		value: function fitPins(pins) {
			var _this = this;
			if (pins.length === 0) {
				return;
			}
			var latLngs = pins.map(function (pin) {
				return pin.model.latlng;
			});
			var bounds = L.latLngBounds(latLngs);

			return new Promise(function (resolve, reject) {
				_this.map.once('viewreset', resolve);
				_this.map.fitBounds(bounds, {
					reset: true,
					animate: false,
					noMoveStart: true,
					maxZoom: _this.map.getZoom(),
					padding: [50, 50]
				});
			});
		}
	}, {
		key: 'updatePinVisibility',
		value: function updatePinVisibility(pin) {
			var _this = this;
			var marker = _this.getPinMarker(pin);
			if (!marker) {
				return;
			}

			return new Promise(function (resolve, reject) {
				if (pin.isVisible()) {
					if (!_this.markersContainer.hasLayer(marker)) {
						// For some reason addLayer causes the marker to change it's LatLng
						// so we buffer it and reapply it
						var markerLatLng = marker.getLatLng();
						var originalIcon = marker._originalIcon || (typeof marker.getIcon === 'function' ? marker.getIcon() : null);

						_this.markersContainer.on('layeradd', function () {
							// Ensure original icon is preserved after adding to cluster
							if (originalIcon && typeof marker.getIcon === 'function' && marker.getIcon() !== originalIcon) {
								marker.setIcon(originalIcon);
							}
							resolve();
						});
						_this.markersContainer.addLayer(marker);
						marker.setLatLng(markerLatLng);
						return;
					}
				} else {
					if (_this.markersContainer.hasLayer(marker)) {
						_this.markersContainer.on('layerremove', resolve);
						_this.markersContainer.removeLayer(marker);
						return;
					}
				}
				resolve();
			});
		}
	}, {
		key: 'refreshClusters',
		value: function refreshClusters() {
			if (this.settings.cluster.enabled) {
				// Force cluster refresh to recalculate counts with only visible markers
				this.cluster.refreshClusters();
			}
		}
	}, {
		key: 'waitForClustersReady',
		value: function waitForClustersReady() {
			var _this = this;
			return new Promise(function (resolve) {
				if (!_this.settings.cluster.enabled || !_this.cluster) {
					resolve();
					return;
				}

				// Wait for cluster layer to be ready and process markers
				var checkCount = 0;
				var maxChecks = 50; // 5 seconds max

				var checkClustersReady = function checkClustersReady() {
					checkCount++;
					var layerCount = _this.cluster.getLayers().length;
					var markerCount = _this.markers.length;

					// Check if we have markers and they've been added to cluster
					if (layerCount > 0 || markerCount === 0 || checkCount >= maxChecks) {
						// Force a refresh to ensure clusters are properly calculated
						_this.cluster.refreshClusters();

						// Trigger cluster animation if needed
						if (_this.cluster._needsClustering && _this.cluster._needsClustering.length > 0) {
							_this.cluster._zoomOrSpiderfy(_this.cluster._needsClustering[0]);
						}

						// Wait for cluster animations to complete
						setTimeout(function () {
							// Final refresh
							_this.cluster.refreshClusters();
							resolve();
						}, 500);
					} else {
						// Retry
						setTimeout(checkClustersReady, 100);
					}
				};

				// Start checking after a small delay to ensure markers are added
				setTimeout(checkClustersReady, 100);
			});
		}
	}, {
		key: 'handleClusterClick',
		value: function handleClusterClick(e) {
			var _this11 = this;

			var cluster = e.layer;
			var markers = cluster.getAllChildMarkers();
			var map = this.map;

			// If cluster only has one marker, just zoom to it and show tooltip
			if (markers.length === 1) {
				var marker = markers[0];
				var _targetZoom = Math.min(map.getMaxZoom(), map.getZoom() + 3);
				map.setView(marker.getLatLng(), _targetZoom);
				// Show tooltip after zoom completes
				setTimeout(function () {
					_this11.showMarkerTooltip(marker);
				}, 300);
				return;
			}

			// Calculate bounds of all markers in cluster
			var group = new L.featureGroup(markers);
			var bounds = group.getBounds();

			// Calculate what zoom level would be needed to separate markers
			var currentZoom = map.getZoom();
			var targetZoom = currentZoom + 2; // Start with +2 levels

			// For very tight clusters, we need more aggressive zooming
			var boundsSize = bounds.getNorthEast().distanceTo(bounds.getSouthWest());

			if (boundsSize < 50) {
				// Very close markers (within 50m)
				targetZoom = Math.min(map.getMaxZoom(), currentZoom + 5);
			} else if (boundsSize < 200) {
				// Close markers (within 200m)
				targetZoom = Math.min(map.getMaxZoom(), currentZoom + 4);
			} else if (boundsSize < 1000) {
				// Moderately close markers (within 1km)
				targetZoom = Math.min(map.getMaxZoom(), currentZoom + 3);
			} else {
				targetZoom = Math.min(map.getMaxZoom(), currentZoom + 2);
			}

			// Ensure we don't exceed max zoom
			targetZoom = Math.min(map.getMaxZoom(), targetZoom);

			// If we're already at max zoom and still clustered, try spiderfy
			if (currentZoom >= map.getMaxZoom() - 1) {
				if (cluster.spiderfy) {
					cluster.spiderfy();
				}
				return;
			}

			// Zoom to the center of the cluster with our calculated zoom level
			var center = bounds.getCenter();
			map.setView(center, targetZoom);
		}
	}, {
		key: 'locate',
		value: function locate() {
			var _this12 = this;

			return new Promise(function (resolve, reject) {
				_this12.map.once('locationfound', resolve);
				_this12.map.once('locationerror', reject);
				_this12.locateControl._onClick();
			});
		}
	}, {
		key: 'redraw',
		value: function redraw() {
			this.map._onResize();
		}

		/**
   * Move marker to a specific position (for route animation)
   * @param {Object} marker - Leaflet marker
   * @param {Object} position - {lat, lng} position
   */

	}, {
		key: 'moveMarkerToPosition',
		value: function moveMarkerToPosition(marker, position) {
			if (marker && marker.setLatLng) {
				marker.setLatLng([position.lat, position.lng]);
			}
		}

		/**
   * Hide marker during animation delay
   * @param {Object} marker - Leaflet marker
   */

	}, {
		key: 'hideMarkerDuringDelay',
		value: function hideMarkerDuringDelay(marker) {
			if (marker) {
				var element = marker.getElement ? marker.getElement() : marker._icon;
				if (element) {
					element.style.opacity = '0';
					element.style.visibility = 'hidden';
					element.style.display = 'none';
				} else {
					// Fallback to Leaflet API if element not accessible
					marker.setOpacity(0);
				}
			}
		}

		/**
   * Show marker after animation delay
   * @param {Object} marker - Leaflet marker
   */

	}, {
		key: 'showMarkerAfterDelay',
		value: function showMarkerAfterDelay(marker) {
			if (marker) {
				var element = marker.getElement ? marker.getElement() : marker._icon;
				if (element) {
					element.style.visibility = 'visible';
					element.style.display = 'block';
					element.style.opacity = '1';
				} else {
					if (marker.setOpacity) marker.setOpacity(1);
				}
			}
		}

		/**
   * Setup animation for a pin along a route
   * @param {Object} pin - Pin object with marker and route data
   * @param {Array} routeWaypoints - Route waypoints
   * @param {Object} animationOptions - Animation settings
   */

	}, {
		key: 'addAnimatedPin',
		value: function addAnimatedPin(pin, routeWaypoints, animationOptions) {
			var _this13 = this;

			var marker = this.getPinMarker(pin);
			if (!marker || !routeWaypoints || routeWaypoints.length < 2) {
				return;
			}

			// If there's a delay, position marker at route start and set up fade-in
			if (animationOptions.delay && animationOptions.delay > 0 && routeWaypoints.length > 0) {
				var startPoint = routeWaypoints[0];
				if (startPoint && startPoint.lat && startPoint.lng) {
					marker.setLatLng([startPoint.lat, startPoint.lng]);
				}

				// Hide marker during delay
				var element = marker.getElement ? marker.getElement() : marker._icon;
				if (element) {
					element.style.opacity = '0';
					element.style.visibility = 'hidden';
					element.style.display = 'none';
				} else {
					// Fallback if element not accessible
					marker.setOpacity(0);
				}
			}

			// Set up hover pause functionality without disrupting existing tooltip events
			// Don't remove existing events - just add animation control
			marker.on('mouseover', function (e) {
				// Pause animation but keep marker at current position
				_this13.routeAnimator.pauseMarker(marker);
			});

			marker.on('mouseout', function (e) {
				// Resume animation after delay to allow tooltip interaction
				setTimeout(function () {
					_this13.routeAnimator.resumeMarker(marker);
				}, 300);
			});

			// Add to route animator
			this.routeAnimator.addAnimatedMarker(marker, routeWaypoints, animationOptions);
		}

		/**
   * Remove animation for a pin
   * @param {Object} pin - Pin object
   */

	}, {
		key: 'removeAnimatedPin',
		value: function removeAnimatedPin(pin) {
			var marker = this.getPinMarker(pin);
			if (marker) {
				this.routeAnimator.removeAnimatedMarker(marker);
			}
		}

		/**
   * Update image tile layer with new tileset URL
   * @param {string} newTilesetUrl - New tileset URL
   */

	}, {
		key: 'updateImageTileLayer',
		value: function updateImageTileLayer(newTilesetUrl) {
			if (this.type === 'image' && newTilesetUrl && newTilesetUrl !== this.currentTilesetUrl) {
				// Remove existing image tile layer
				if (this.layers['image'] && this.layers['image'].length > 0) {
					this.map.removeLayer(this.layers['image'][0]);
				}

				// Create new tile layer with updated URL
				this.layers['image'] = [L.tileLayer(newTilesetUrl.replace(/\/+$/, '') + '/z{z}-tile_{y}_{x}.png', {
					minZoom: -2,
					maxZoom: 4,
					noWrap: true,
					tms: true
				})];

				// Add new layer to map
				this.map.addLayer(this.layers['image'][0]);

				// Update stored URL
				this.currentTilesetUrl = newTilesetUrl;
			}
		}

		/**
   * Fetch current temperature for coordinates using OpenWeatherMap API
   * @param {number} lat - Latitude
   * @param {number} lng - Longitude
   * @param {string} format - Temperature format ('fahrenheit' or 'celsius')
   * @returns {Promise<Object>} Temperature data with current, high, low, and format
   */

	}, {
		key: 'fetchCurrentTemperature',
		value: function fetchCurrentTemperature(lat, lng) {
			var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fahrenheit';

			var apiKey = '735a344e3f83e55094c82850dacd3816';
			var units = format === 'celsius' ? 'metric' : 'imperial';
			var url = 'https://api.openweathermap.org/data/2.5/weather?lat=' + lat + '&lon=' + lng + '&appid=' + apiKey + '&units=' + units;

			return fetch(url).then(function (response) {
				if (!response.ok) {
					throw new Error('Weather API error: ' + response.status);
				}
				return response.json();
			}).then(function (data) {
				if (data && data.main && typeof data.main.temp === 'number') {
					return {
						current: data.main.temp,
						high: data.main.temp_max,
						low: data.main.temp_min,
						format: format
					};
				}
				throw new Error('Invalid weather data format');
			}).catch(function (error) {
				console.error('Failed to fetch temperature:', error);
				throw error;
			});
		}

		/**
   * Check if route animation is supported
   * @returns {boolean}
   */

	}, {
		key: 'supportsRouteAnimation',
		value: function supportsRouteAnimation() {
			return true;
		}
	}]);

	return LeafletOSMMapService;
}(MapService);

;

module.exports = LeafletOSMMapService;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map-services/leaflet-osm-map-service.js
// module id = 17
// module chunks = 0